// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
	position: fixed;
	top: 120px;
	right: 20px;
	max-width: 350px;
	max-height: 150px;
	z-index: 1000;
}

.modal-box {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	padding: 15px 20px;
	border-radius: 10px;
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
	animation: slideIn 0.3s ease-out;
	font-size: 20px;
}

.modal-box.error {
	background-color: rgb(252, 45, 45);
	border: 2px solid red;
	color: white;
	text-shadow: 1px 1px black;
}

.modal-box.success {
	background-color: rgb(17, 202, 17);
	border: 2px solid green;
	color: white;
	text-shadow: 1px 1px black;
}

@keyframes slideIn {
	from {
		transform: translateX(100%);
		opacity: 0;
	}
	to {
		transform: translateX(0);
		opacity: 1;
	}
}

@media (max-width: 768px) {
	.modal-box {
		font-size: 1rem;
	}
}

@media (max-width: 480px) {
	.modal-box {
		font-size: 12px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/Modal/Modal.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,UAAU;CACV,WAAW;CACX,gBAAgB;CAChB,iBAAiB;CACjB,aAAa;AACd;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,wCAAwC;CACxC,gCAAgC;CAChC,eAAe;AAChB;;AAEA;CACC,kCAAkC;CAClC,qBAAqB;CACrB,YAAY;CACZ,0BAA0B;AAC3B;;AAEA;CACC,kCAAkC;CAClC,uBAAuB;CACvB,YAAY;CACZ,0BAA0B;AAC3B;;AAEA;CACC;EACC,2BAA2B;EAC3B,UAAU;CACX;CACA;EACC,wBAAwB;EACxB,UAAU;CACX;AACD;;AAEA;CACC;EACC,eAAe;CAChB;AACD;;AAEA;CACC;EACC,eAAe;CAChB;AACD","sourcesContent":[".modal-overlay {\n\tposition: fixed;\n\ttop: 120px;\n\tright: 20px;\n\tmax-width: 350px;\n\tmax-height: 150px;\n\tz-index: 1000;\n}\n\n.modal-box {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\twidth: 100%;\n\theight: 100%;\n\tpadding: 15px 20px;\n\tborder-radius: 10px;\n\tbox-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n\tanimation: slideIn 0.3s ease-out;\n\tfont-size: 20px;\n}\n\n.modal-box.error {\n\tbackground-color: rgb(252, 45, 45);\n\tborder: 2px solid red;\n\tcolor: white;\n\ttext-shadow: 1px 1px black;\n}\n\n.modal-box.success {\n\tbackground-color: rgb(17, 202, 17);\n\tborder: 2px solid green;\n\tcolor: white;\n\ttext-shadow: 1px 1px black;\n}\n\n@keyframes slideIn {\n\tfrom {\n\t\ttransform: translateX(100%);\n\t\topacity: 0;\n\t}\n\tto {\n\t\ttransform: translateX(0);\n\t\topacity: 1;\n\t}\n}\n\n@media (max-width: 768px) {\n\t.modal-box {\n\t\tfont-size: 1rem;\n\t}\n}\n\n@media (max-width: 480px) {\n\t.modal-box {\n\t\tfont-size: 12px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
